import { QueryClient } from "@tanstack/react-query";

const CACHE_TIME = 30 * 60 * 1000; // 30 minutos
const STALE_TIME = 30 * 60 * 1000; // 30 minutos

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      cacheTime: CACHE_TIME,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
